import styled from 'styled-components';

export const Title = styled.h2`
  text-align: center;
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  min-height: calc(100vh - 240px);
  color: #1c1c1c;

  .font-warning{
    color: #d63031;
  }

  font-size: 0.7em;

  @media (min-width: 64.5em) {
    font-size: .9em !important;
  }  
`;

export const Error = styled.h1`
  text-align: center;
  font-size: 7em;
  line-height: 0.8;
`;

export const Description = styled.p`
  text-align: center;
`;